<template>
  <!-- <Dialog v-model:visible="showDialog" :modal="true" :header="$t('group.title')"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }"> -->
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :header="model ? $t('accountHead.Edittitle') : $t('accountHead.title')"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              :required-icon="false"
              id=""
              name="code"
              :label="$t('accountHead.code')"
              :rules="{ required: false }"
              v-model="Groupform.Code"
              type="text"
              placeholder=" "
              disabled
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="true"
              id="Account Head Name"
              name="Account Head Name"
              :label="$t('accountHead.name')"
              :rules="{ required: true }"
              v-model="Groupform.Name"
              type="text"
              placeholder=" "
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <CustomDropdown
            :required-icon="true"
            :label="$t('accountHead.Nature')"
            v-model="Groupform.NatureId"
            :rules="{ required: true }"
            :name="$t('accountHead.Nature')"
            :id="$t('accountHead.Nature')"
            :items="natureOptions"
            @update:model-value="handlenatureChange"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <!-- {{ balanceTypeOptions }} -->
          <CustomDropdown
            :required-icon="true"
            :label="$t('accountHead.EntryType')"
            v-model="Groupform.EntryType"
            :rules="{ required: true }"
            :name="$t('accountHead.EntryType')"
            :id="$t('accountHead.EntryType')"
            :items="balanceTypeOptions"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <CustomDropdown
            :required-icon="true"
            :label="$t('accountHead.ReportCategory')"
            v-model="Groupform.ReportCategoryId"
            :rules="{ required: true }"
            :name="$t('accountHead.ReportCategory')"
            :id="$t('accountHead.ReportCategory')"
            :items="reportCategoryOptions"
            @update:model-value=""
          />
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="false"
              id="Description"
              name="Description"
              :label="$t('accountHead.Description')"
              :rules="{ required: false }"
              v-model="Groupform.Description"
              type="text"
              placeholder=""
            />
          </div>
        </b-col>
      </b-row> -->
      <Footer
        @cancel="(showDialog = false), IsClear()"
        :cancelhide="false"
        :label="label"
        :loading="Saveloading"
      />
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit()"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <accountSubHeadCreation
    v-model:trigger="DialogShow.AccountSubHead"
    v-if="DialogShow.AccountSubHead"
    @load="accountSubHeaddropdownapi(), (DialogShow.AccountSubHead = false)"
    @close="DialogShow.AccountSubHead = false"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.AccountSubHead"
  />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import AccountHeadService from "../../../../../../modules/Inventory/Service/AccountHeadService";
import AccountSubHeadService from "../../../../../../modules/Inventory/Service/AccountSubHeadService";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";
import accountSubHeadCreation from "../../../../../../modules/Inventory/pages/Masters/Items/AccountSubHead/accountSubHeadCreation.vue";
import MastersService from "../../../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import { number } from "yup";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },

  components: {
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    TextField,
    CustomDropdown,

    Footer,
    accountSubHeadCreation,
  },

  setup(props, { emit }) {
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");
    const toast = useToast();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Saveloading = ref(false);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      AccountSubHead: false,
    });
    let EntityIds = ref({
      AccountSubHead: 329,
    });
    const label = ref(t("btn.save"));

    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      LoadNatureList();
      LoadReportCategoryList();
    });
    const balanceTypeOptions = ref([
      { name: "Credit", value: 1 },
      { name: "Debit", value: 2 },
    ]);
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        IsSubmit();
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      // showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
      // else if (event.key == 'e') {
      // IsEdit()
      // }
      // else if (event.key == 'Escape') {

      // IsClear()
      // }
    }
    //Table data Variable
    let items = ref([]);
    //update and create jsonrequest

    let natureOptions = ref({});

    let reportCategoryOptions = ref({});

    //Request form
    const Groupform: any = ref({
      Id: 0,
      Name: "",
      Code: "",
      AccountSubHeadId: ref(),
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      Description: "",
      NatureId: 0,
      EntryType: 0,
      ReportCategoryId: 0,
      ParentId: 0,
      Level: 0,
      BalanceSheetNotes: "",
      ScheduleNumber: "",
      Status: "1",
      OrganizationId: 0,
    });

    //Editable
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");

      try {
        label.value = t("btn.update");
        let Id = model.value.Id;
        const response = await AccountHeadService.getfindonedata(
          Id,
          HospitalId
        );
        let data = response["result"];

        Object.keys(Groupform.value).forEach((key) => {
          if (data[key]) Groupform.value[key] = data[key];
        });
        Groupform.value.EntryType =
          data.EntryType === "Credit" ? 1 : data.EntryType === "Debit" ? 2 : 0;
        // category.value.AccountSubHeadId = data.Id;
        Editmodel.value = false;
        emit("loaderhide");

        // showDialog.value = true;
      } catch (error) {
        showDialog.value = false;
        emit("loaderhide");
        alert(error);
      }
    }
    //Submit Function
    const IsSubmit = async () => {
      debugger;
      emit("loadershow");
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        Groupform.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        Groupform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        Groupform.value.BranchId = BranchId;
        Groupform.value.HospitalId = HospitalId;
        Groupform.value.ModifiedBy = UserId;
        Groupform.value.CreatedBy = UserId;
        Groupform.value.EntityId = Number(Entitydata.value.EntityId);
        const entryTypeValue = Groupform.value.EntryType;
        Groupform.value.OrganizationId = HospitalId;
        Groupform.value.EntryType =
          entryTypeValue == 1 ? "Credit" : entryTypeValue == 2 ? "Debit" : "";
        console.log(Groupform.value.AccountSubHeadId);
        if (Groupform.value.Id != 0) {
          Groupform.value.EntityOperationId = props.OperationID.UpdateId;
          const response = await AccountHeadService.updatedata(Groupform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            emit("loaderhide");
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            emit("loaderhide");
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("Something went wrong");
          }
        } else {
          Groupform.value.EntityOperationId = props.OperationID.CreateId;
          const response = await AccountHeadService.createdata(Groupform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            emit("loaderhide");
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            emit("loaderhide");
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("Something went wrong");
          }
        }
        // showDialog.value = false
        // emit('load')
        // IsClear();
      } catch (error) {
        emit("loaderhide");
        Saveloading.value = false;
        alert(error);
      }
    };
    //Clear Function
    const copydataModel = JSON.parse(JSON.stringify(Groupform.value));
    const copySelectOption = JSON.parse(JSON.stringify(Groupform.value));

    const IsClear = () => {
      Object.assign(Groupform.value, copydataModel);
      Object.assign(category.value.AccountSubHeadOption, copySelectOption);
      emit("update:selectedItem", undefined);
      emit("close");
    };
    //Account Sub Head dropdown
    const category = ref({
      AccountSubHeadId: null,
      AccountSubHeadOption: [],
    });
    //Account Sub Head dropdown Api Call
    async function accountSubHeaddropdownapi() {
      debugger;
      try {
        debugger;
        const response = await AccountSubHeadService.getdata();
        items.value = response["result"].reverse();
        console.log(items.value);
        category.value.AccountSubHeadOption = response["result"]
          .filter(
            (items) => items.HospitalId == HospitalId //&& items.BranchId == BranchId
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 23,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
        Iscommon: 1,
        RoleId: rolesData.RoleId || 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      Groupform.value.Code = result;
      if (result) {
        showDialog.value = true;
      }
    }
    async function IsEditpop() {
      Editmodel.value = true;
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    const alreadyexistpop = ref(false);

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      Groupform.value.Name = ""; //showDialog.value = true
    }
    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    async function LoadNatureList() {
      try {
        const response = await AccountHeadService.getNatureOfGroupList();

        natureOptions.value = response["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    }

    async function LoadReportCategoryList() {
      try {
        const response = await AccountHeadService.getReportCategoryList();

        reportCategoryOptions.value = response["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    }

    const handlenatureChange = async () => {
      debugger;
      try {
        const selectednature = natureOptions.value.find(
          (g: any) => g.Id === Groupform.value.NatureId
        );

        if (selectednature) {
          Groupform.value.EntryType = Number(
            selectednature.EntryType == "Debit"
              ? 2
              : selectednature.EntryType == "Credit"
              ? 1
              : 0
          );
          Groupform.value.ReportCategoryId = selectednature.ReportCategoryId;
        } else {
          console.log(
            "No matching nature found for NatureId:",
            Groupform.value.NatureId
          );
          Groupform.value.EntryType = 0;
          Groupform.value.ReportCategoryId = 0;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    return {
      Saveloading,
      model,
      ObjOperationId,
      EntityIds,
      DialogShow,
      FunctionRights,
      alreadyclosetrigger,
      alreadyexistpop,
      IsEditpop,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      IsEdit,
      IsCreate,
      showDialog,
      IsClear,
      Groupform,
      items,
      category,
      accountSubHeaddropdownapi,
      IsSubmit,
      GetCode,
      label,
      LoadNatureList,
      natureOptions,
      balanceTypeOptions,
      handlenatureChange,
      LoadReportCategoryList,
      reportCategoryOptions,
    };
  },
  created() {
    this.accountSubHeaddropdownapi();
  },
});
</script>
